import { render, staticRenderFns } from "./OfferTableRejected.vue?vue&type=template&id=1f206fdc"
import script from "./OfferTableRejected.vue?vue&type=script&lang=js"
export * from "./OfferTableRejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports